import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { User } from '@app/_models';


@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
/*     user: User;

    constructor(private accountService: AccountService,) {
        this.user = this.accountService.userValue;
    } */
    constructor(private router: Router) {

    }

    cessModuleRedirect()
    {
      this.router.navigate(["/cess-payment/login"]);
    }
    feepaymentRedirect()
    {
      this.router.navigate(["/payment/get-student"]);
    }

}
